import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import geometricAnalysisReducer from './data/geometricAnalysisData/reducer';
import geometricAnalysisSagas from './data/geometricAnalysisData/sagas';
import partFileCadDataReducer from './data/partFileCadData/reducer';
import partFileCadDataSagas from './data/partFileCadData/sagas';
import cadViewerReducer from './data/reducer';
import cadViewerSagas from './data/sagas/index';

export const reducer = combineReducers({
  cadViewer: cadViewerReducer,
  geometricAnalysis: geometricAnalysisReducer,
  partFileCadData: partFileCadDataReducer,
});

export const saga = function* () {
  yield all([
    cadViewerSagas(),
    geometricAnalysisSagas(),
    partFileCadDataSagas(),
  ]);
};
